import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const styles = {
  wrapper: {
    color: '#e0e0e0',
    fontSize: 15,
    lineHeight: 1.75,
  },
};

const components = {
  h1: ({ children }) => (
    <h1 style={{ color: 'var(--c-acento)', fontSize: 22, fontWeight: 700, marginBottom: 8, marginTop: 0 }}>
      {children}
    </h1>
  ),
  h2: ({ children }) => (
    <h2 style={{ color: '#b8ccde', fontSize: 17, fontWeight: 700, marginTop: 28, marginBottom: 8, borderBottom: '1px solid rgba(255,255,255,0.08)', paddingBottom: 6 }}>
      {children}
    </h2>
  ),
  h3: ({ children }) => (
    <h3 style={{ color: '#90caf9', fontSize: 15, fontWeight: 600, marginTop: 20, marginBottom: 6 }}>
      {children}
    </h3>
  ),
  p: ({ children }) => (
    <p style={{ marginTop: 0, marginBottom: 14 }}>{children}</p>
  ),
  ul: ({ children }) => (
    <ul style={{ paddingLeft: 20, marginBottom: 14, marginTop: 0 }}>{children}</ul>
  ),
  ol: ({ children }) => (
    <ol style={{ paddingLeft: 20, marginBottom: 14, marginTop: 0 }}>{children}</ol>
  ),
  li: ({ children }) => (
    <li style={{ marginBottom: 6 }}>{children}</li>
  ),
  strong: ({ children }) => (
    <strong style={{ color: '#ffffff', fontWeight: 600 }}>{children}</strong>
  ),
  em: ({ children }) => (
    <em style={{ color: '#90caf9' }}>{children}</em>
  ),
  code: ({ inline, children }) =>
    inline ? (
      <code style={{
        background: 'rgba(144,202,249,0.12)', color: '#90caf9',
        padding: '1px 6px', borderRadius: 4, fontSize: 13, fontFamily: 'monospace',
      }}>
        {children}
      </code>
    ) : (
      <pre style={{
        background: '#0f1928', border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: 6, padding: '12px 16px', overflowX: 'auto',
        fontSize: 13, fontFamily: 'monospace', marginBottom: 14,
      }}>
        <code>{children}</code>
      </pre>
    ),
  blockquote: ({ children }) => (
    <blockquote style={{
      borderLeft: '3px solid var(--c-acento)', paddingLeft: 14,
      margin: '0 0 14px 0', color: '#90a4ae', fontStyle: 'italic',
    }}>
      {children}
    </blockquote>
  ),
  hr: () => (
    <hr style={{ border: 'none', borderTop: '1px solid rgba(255,255,255,0.08)', margin: '20px 0' }} />
  ),
  table: ({ children }) => (
    <div style={{ overflowX: 'auto', marginBottom: 14 }}>
      <table style={{ borderCollapse: 'collapse', width: '100%', fontSize: 14 }}>
        {children}
      </table>
    </div>
  ),
  th: ({ children }) => (
    <th style={{ padding: '8px 12px', background: 'var(--c-primario)', color: '#e0e0e0', textAlign: 'left', fontWeight: 600, fontSize: 13 }}>
      {children}
    </th>
  ),
  td: ({ children }) => (
    <td style={{ padding: '7px 12px', borderBottom: '1px solid rgba(255,255,255,0.07)', color: '#d0d0d0' }}>
      {children}
    </td>
  ),
};

export default function MarkdownRenderer({ children }) {
  return (
    <div style={styles.wrapper}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
        {children}
      </ReactMarkdown>
    </div>
  );
}
